import * as React from 'react';
import { ButtonPrimary, Textarea } from 'ui';
import { CloseOnBlur } from 'ui/common/close-on-blur';
import { OnClickOutside } from 'ui/common/on-click-outside';
import styles from './file-uploader.scss';

export interface FileUploaderEditTitleProps {
  title: string;
  textDone: string;
  onChange: (newValue: string) => void;
}

export interface FileUploaderEditTitleState {
  title: string;
}

export class FileUploaderItemEditTitle extends React.Component<FileUploaderEditTitleProps, FileUploaderEditTitleState> {

  constructor(props: any) {
    super(props);
    this.state = {
      title: props.title
    };
  }

  private onChange = (newValue: string) => {    
    this.setState({
      title: newValue
    });
  };

  private onDone = () => {
    this.props.onChange(this.state.title);
  };

  private onCancel = () => {
    this.props.onChange(this.props.title);
  };

  public render() {
    return (
      <CloseOnBlur onBlur={this.onCancel}>
        <OnClickOutside onClickOutside={this.onCancel}>          
          <div className={`${styles.editInputContainer} form-group`}>
            <Textarea className={styles.editInput} value={this.state.title} onChange={this.onChange} wait={100} focus={true}/>            
            <span className={`${styles.editDoneBtn} input-group-button`}>
              <ButtonPrimary onClick={this.onDone}>
                {this.props.textDone}
              </ButtonPrimary>
            </span>
          </div>
        </OnClickOutside>
      </CloseOnBlur>
    );
  }
}
